import type { PocTableRowCustomEvent } from 'commons/types';
import { useCallback, useEffect, useRef, useState } from 'react';
import { ActiveDirectoryListItem } from '../active-directory-list-item.vm';

interface UseActiveDirectoryListProps {
    activeDirectories: ActiveDirectoryListItem[];
}

export const useActiveDirectoryList = ({ activeDirectories }: UseActiveDirectoryListProps) => {
    const [selectedRows, setSelectedRows] = useState<ActiveDirectoryListItem[]>([]);
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    const handleOnSelectRows = useCallback(
        (activeDirectoryId: string, event: PocTableRowCustomEvent<boolean>) => {
            const directory = activeDirectories.find((ad) => ad.id === activeDirectoryId);
            if (!directory) {
                return;
            }

            setSelectedRows((prevSelectedRows) =>
                event.detail
                    ? [...prevSelectedRows, directory]
                    : prevSelectedRows.filter((prevSelectedRow) => prevSelectedRow.id !== activeDirectoryId)
            );
        },
        [activeDirectories]
    );

    useEffect(() => {
        setSelectedRows([]);
    }, [activeDirectories]);

    return {
        selectedRows,
        scrollContainerRef,
        setSelectedRows,
        handleOnSelectRows,
    };
};
